import { render, staticRenderFns } from "./DetailsDossier.vue?vue&type=template&id=490854d6&scoped=true&"
import script from "./DetailsDossier.vue?vue&type=script&lang=ts&"
export * from "./DetailsDossier.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsDossier.vue?vue&type=style&index=0&id=490854d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490854d6",
  null
  
)

export default component.exports